import TemplateForm from './templateForm';

const NewTemplate = (props) => {
    return (
        <TemplateForm {...props} />
    )
}

export default NewTemplate;